import { forwardRef, memo } from 'react';

interface IndeterminateIconProps {
  color?: string;
}

export const IndeterminateIcon = memo(
  forwardRef<SVGSVGElement, IndeterminateIconProps>(function IndeterminateIcon({ color }, ref) {
    return (
      <svg ref={ref} width='12' height='2' viewBox='0 0 12 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.3334 0.333344H0.666779L0.666779 1.66668H11.3335L11.3334 0.333344Z'
          fill={color}
        />
      </svg>
    );
  }),
);
